import '../../shared/config/unpoly.js'
import '../../shared/config/unpoly.sass'

up.link.config.preloadSelectors.push('a[href]')

up.history.config.enabled = false
